import { SvgIcon, Text, useText } from "@sveabank/cc-common";
import { useLocation } from "react-router";
import type { NavPage } from "../../../types/navigation";

type Props = {
	pages: NavPage[];
};

const MobileNavLabel = ({ pages }: Props) => {
	const location = useLocation();
	const currentPage = pages.find((page) => location.pathname === page.url);
	const [t, texts] = useText();

	return (
		<div className="relative mx-1 flex w-full grow-0 items-center justify-center gap-2">
			{currentPage && (
				<>
					{currentPage.hasWarning && (
						<SvgIcon height={24} imageSrc="ALERT_FILLED" className="text-foreground-alert" />
					)}
					<Text bold className="text-interactive-primary text-sm">
						{`${currentPage.label} - ${t(
							texts.navbar.navItem.stepPresentation,
							currentPage.stepNumber.toString(),
							currentPage.totalSteps.toString(),
						)}`}
					</Text>
				</>
			)}
		</div>
	);
};

export default MobileNavLabel;
